<script lang="ts">
    import { xFirstDot, yLineInterval } from "../config/lengths";
    import DotsComponent from "./DotsComponent.svelte";

    export let xRel: number;
    export let xLeftEnd: number;
    export let xRightEnd: number;
    export let yMiddle: number;
    export let dots: number;

    $: cx = xLeftEnd + xRel * (xRightEnd - xLeftEnd);

    $: scale = yLineInterval / 40;
</script>

<path
    style="fill: #000000; fill-rule: evenodd; stroke-width: 0"
    d="m -16.211221,-70.215638 c -1.61619,1.614428 -1.011,3.125643 1.00395,5.644331 2.01495,2.51869 16.8752195,21.912602 17.1270895,23.675682 0.25187,1.76308 -14.3565295,36.0172608 -14.1046595,39.0396808 0.25187,3.02243 23.641819,32.2836802 23.641819,32.2836802 0,0 -6.1681595,-5.06483 -13.8442995,-6.74396 -5.74739,-1.25721 -11.6310095,0.39343 -16.1196095,6.29672 -4.90857,6.45564 -6.47301,15.64047 -2.24145,23.57473 3.66088,6.86424 13.6009195,15.37074 18.8901695,15.364 4.18228,-0.005 4.28177,-1.00747 3.52616,-2.26682 -0.75560996,-1.25934 -19.3229595,-17.78691 -7.05233,-26.94997 10.05045,-7.50515 20.7031805,-1.07037 22.4662605,0.44084 1.76308,1.51121 3.5431,3.29123 5.80992,1.52815 2.26682,-1.76308 3.50923,-2.03189 -0.0169,-5.80992 -3.52617,-3.77803 -10.88029,-13.53803 -13.3989805,-20.59036 -2.51869,-7.0523302 -3.02243,-9.3191502 -0.75561,-14.6084002 2.2668195,-5.28925 13.0971905,-29.7205298 12.3415805,-32.4910898 -0.75561,-2.770561 -32.73768,-36.767581 -33.74515,-37.775056 -1.00748,-1.007475 -1.91526,-2.020238 -3.52793,-0.612238 z"
    transform="scale({scale}) translate({cx / scale} {yMiddle / scale})"
/>
<DotsComponent xFirstDotAbs={cx + xFirstDot * 1.1} {dots} yRel={0} {yMiddle} />
